module.exports = __webpack_public_path__ + "img/icon-title-2.cf765cb0.png";